<template>
  <div class="header-components" id="top_position">
    <MyModal @close="closeModal" v-if="modal">
      <!-- default スロットコンテンツ -->
      <div class="entry-wrapper">
        <p class="message mincho">
          当社へのエントリーは<br>
          「リクナビ」「マイナビ」よりお願いします。
        </p>
        <div class="entry-button-wrap">
          <!-- <div class="entry21-wrap"> -->
            <a href="https://job.rikunabi.com/2023/company/r578300040/" target="_blank" rel=noopener>
              <img src="../assets/img/common/entry/rikunav2021.png" alt="リクナビ2021">
            </a>
            <a href="https://job.mynavi.jp/23/pc/search/corp82877/outline.html" target="_blank" rel=noopener>
              <img src="../assets/img/common/entry/mynav2021.png" alt="マイナビ2021">
            </a>
          <!-- </div> -->
        </div>
      </div>
      <!-- /default -->
    </MyModal>
    <header class="header" v-bind:class="{'is-open': navOpen}">
      <div class="logo">
        <router-link to="/">
          <img src="../assets/img/common/sitelogo.svg" alt="" width="278px">
        </router-link>
      </div>
      <nav class="nav">
        <div class="nav-inner">
          <router-link to="/">
            ホーム
          </router-link>
          <router-link to="/job">
            働きかた
          </router-link>
          <router-link to="/person">
            求める人物像
          </router-link>
          <router-link to="/education">
            教育・研修
          </router-link>
          <router-link to="/about">
            会社について
          </router-link>
          <router-link to="/welfare">
            働きやすさ
          </router-link>
          <router-link to="/faq">
            Q&A
          </router-link>
          <router-link to="/schedule">
            1日の仕事
          </router-link>
          <div class="entry-button Longfont" @click="openModal">
            ENTRY
            <img src="../assets/img/common/icon/simple_arrow_next_black.svg" width="10px">
          </div>
        </div>
      </nav>
      <div class="minimum-nav">
        <div class="entry-button Longfont" @click="openModal">
          ENTRY
          <img src="../assets/img/common/icon/simple_arrow_next_black.svg" width="10px">
        </div>
        <div class="humberger-button" v-on:click='navOpen=!navOpen'>
          <div class="humberger-button-inner">
            <i></i>
            <i></i>
            <i></i>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import MyModal from '@/components/MyModal.vue'
export default {
  name: 'Header',
  components: {
    MyModal,
  },
  data() {
    return {
      navOpen: false,
      modal: false,
    }
  },
  methods: {
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false
    },
  },
  watch: {
    '$route': function (to, from) {
      if (to.path !== from.path) {
       this.navOpen = false;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.header-components {
  position: relative;
  @media print, screen and (max-width: 960px) {
    padding-bottom: 100px;
  }
}
.entry-wrapper {
  max-width: 530px;
  width: 100%;
  margin: 0 auto;
  .message {
    text-align: center;
    font-size: 20px;
    @media print, screen and (max-width: 960px) {
      font-size: 13px;
    }
  }
  .entry-button-wrap {
    display: flex;
    justify-content: space-between;
    @media print, screen and (max-width: 960px) {
      display: block;
    }
    a {
      width: 100%;
      display: block;
      margin: 0 auto;
      max-width: 250px;
    }
  }
  // .entry20-wrap,.entry21-wrap {
  //   max-width: 250px;
  //   width: 100%;
  //   margin: 0 auto;
  //   img,a {
  //     margin-top: 10px;
  //   }
  // }
}
.header {
  position: fixed;
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: 20px;
  z-index: 100;
  @media print, screen and (max-width: 1000px) {
    justify-content: space-between;
    align-items: flex-start;
  }
  .logo {
    margin-left: 20px;
    max-width: 50%;
    a {
      display: block;
    }
    img {
      vertical-align: middle;
      @media print, screen and (max-width: 1000px) {
        vertical-align: top;
      }
    }
  }
  .nav {
    position: absolute;
    right: 0;
    @media print, screen and (max-width: 1000px) {
      background-color: #ffce48;
      width: 200px;
      height: 100vh;
      padding-top: 80px;
      top: 0;
      right: -100%;
      transition: right 0.2s cubic-bezier(0.86, 0, 0.07, 1);
    }
  }
  .nav-inner {
    display: flex;
    align-items: center;
    position: relative;
    @media print, screen and (max-width: 1000px) {
      align-items: baseline;
      flex-direction: column;
      z-index: 10;
      left: 50%;
      transform: translateX(-50%);
      display: inline-flex;
    }
    a {
      color: #e51c57;
      font-size: 12px;
      margin-right: 15px;
      @media print, screen and (max-width: 1000px) {
        color: #333333;
        font-size: 16px;
        line-height: 3em;
      }
      &:after {
        @media print, screen and (min-width: 1001px) {
          content: "";
          width: 0%;
          height: 3px;
          background-color: #ffce48;
          display: block;
          transition: width 0.2s ease-out,color 0.2s ease-out;
        }
      }
    }
    a:hover {
      @media print, screen and (min-width: 1001px) {
        color: #ffce48;
      }
      &:after {
        width: 100%;
      }
    }
    .router-link-exact-active {
      @media print, screen and (min-width: 1001px) {
        color: #ffce48;
      }
      &:after {
        width: 100%;
      }
    }
    .entry-button {
      cursor: pointer;
      width: 130px;
      height: 40px;
      background-color: #ffce48;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px 0px 0px 5px;
      transition: opacity 0.2s ease-out;
      letter-spacing: 0.2em;
      @media print, screen and (max-width: 1000px) {
        background-color: #e51c57;
        color: #fff;
        border-radius: 5px;
        margin-top: 1em;
      }
      &:hover {
        opacity: 0.5;
      }
      img {
        vertical-align: middle;
        padding: 0 1em;
      }
    }
  }
  &.is-open {
    .nav {
      right: 0;
    }
    .humberger-button {
      background-color: #333333;
    }
    .humberger-button-inner {
      i {
        background-color: #ffce48;
        &:nth-child(1){
          transform: rotate(45deg) scale(0.8, 0.05);
        }
        &:nth-child(2){
          transform: rotate(-45deg) scale(0.8, 0.05);
        }
        &:nth-child(3){
          transform: rotate(45deg) scale(0.8, 0.05);
        }
      }
    }
  }
}
.minimum-nav {
  display: none;
  right: 0;
  @media print, screen and (max-width: 1000px) {
    display: flex;
  }
  .entry-button {
    cursor: pointer;
    width: 80px;
    height: 60px;
    background-color: #ffce48;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px 0px 0px 5px;
    transition: opacity 0.2s ease-out;
    letter-spacing: 0.2em;
    margin-right: 3px;
    img {
      vertical-align: middle;
      margin-left: 5px;
    }
  }
  .humberger-button {
    width: 60px;
    height: 60px;
    background-color: #ffce48;
    z-index: 1;
  }
  .humberger-button-inner {
    margin: 0 auto;
    position: relative;
    top: 10px;
    left: 15px;
    width: 30px;
    height: 40px;
    display: inline-block;
    vertical-align: bottom;
    transition-duration: 0.2s;
    transition-animation-timing: ease-out;
    i {
      position: absolute;
      display: block;
      width: 100%;
      height: 100%;
      background: #000;
      transition: transform 0.2s cubic-bezier(0.86, 0, 0.07, 1);
      &:nth-child(1){
        transform: scale(0.8, 0.05);
      }
      &:nth-child(2){
        transform: scale(0.8, 0.05) translate(0, -550%);
      }
      &:nth-child(3){
        transform: scale(0.8, 0.05) translate(0, 550%);
      }
    }
  }
}
</style>
